import { FormlyFieldConfig } from '@ngx-formly/core';
import { advancedSection, COMMON_FIELD_CONFIGS } from './field-config-shared';

/**
 * text-label: type → label → content (mde-editor) → fontSize → fontWeight → color → textAlign → tag
 *             → [Advanced: width]
 *
 * The content field uses the 'mde-editor' Formly type which wraps TextLabelMdeEditorComponent.
 * Static select options (fontSize, fontWeight, textAlign) use translation keys as labels;
 * these are translated by GenericFieldConfigEditorComponent.translateFormFields() before rendering.
 */
export function getTextLabelFieldConfigFields(): FormlyFieldConfig[] {
  return [
    COMMON_FIELD_CONFIGS['type'],
    COMMON_FIELD_CONFIGS['label'],
    {
      key: 'content',
      type: 'mde-editor',
      className: 'flex-basis-full',
      props: {
        label: 'formBuilder.content',
        placeholder: 'formBuilder.contentPlaceholder',
      },
    },
    {
      key: 'fontSize',
      type: 'select',
      props: {
        label: 'formBuilder.textLabel.fontSize',
        options: [
          { value: '', label: 'formBuilder.textLabel.fontSize.default' },
          { value: 'sm', label: 'formBuilder.textLabel.fontSize.sm' },
          { value: 'md', label: 'formBuilder.textLabel.fontSize.md' },
          { value: 'lg', label: 'formBuilder.textLabel.fontSize.lg' },
          { value: 'xl', label: 'formBuilder.textLabel.fontSize.xl' },
        ],
      },
    },
    {
      key: 'fontWeight',
      type: 'select',
      props: {
        label: 'formBuilder.textLabel.fontWeight',
        options: [
          { value: 'normal', label: 'formBuilder.textLabel.fontWeight.normal' },
          { value: 'bold', label: 'formBuilder.textLabel.fontWeight.bold' },
          { value: 'light', label: 'formBuilder.textLabel.fontWeight.light' },
        ],
      },
    },
    {
      key: 'color',
      type: 'text',
      props: {
        type: 'color',
        label: 'formBuilder.textLabel.color',
      },
    },
    {
      key: 'textAlign',
      type: 'select',
      props: {
        label: 'formBuilder.textLabel.textAlign',
        options: [
          { value: '', label: 'formBuilder.textLabel.textAlign.default' },
          { value: 'left', label: 'formBuilder.textLabel.textAlign.left' },
          { value: 'center', label: 'formBuilder.textLabel.textAlign.center' },
          { value: 'right', label: 'formBuilder.textLabel.textAlign.right' },
        ],
      },
    },
    {
      key: 'tag',
      type: 'text',
      props: {
        label: 'formBuilder.tag',
        placeholder: 'formBuilder.tagPlaceholder',
      },
    },
    advancedSection(COMMON_FIELD_CONFIGS['width']),
  ];
}
